import { SalaryTypeOption } from "@hr/api/model";
import { SelectOption } from "@hr/common/types.ts";

export const getContextMenuItemsForMappings = () => {
  let items = [];

  items.push("export");

  return items;
};

// Unused, duplicate of usePayTypeOptions("ESALARY/PROCOUNTOR", "ABSENCE/FULL")
export const getSalaryTypeOptionsForSelect = (salaryTypeOptions: SalaryTypeOption[]): SelectOption[] => {
  return salaryTypeOptions
    ? salaryTypeOptions?.map(({ code, name }) => ({
        value: `${code}`,
        label: `${code} ${name}`,
      }))
    : [];
};
